import { Component, Input, AfterViewInit, OnDestroy, ElementRef, ChangeDetectionStrategy, DestroyRef, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { registerLayout, unregisterLayout } from '../../features/layout.actions';
import { ResizeService } from '../../services/resize.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';

@Component({
  standalone:true,
  imports:[CommonModule],
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements AfterViewInit, OnDestroy {
  destroyRef = inject(DestroyRef)
  @Input()
  public name: string = null;

  public boundingClientRect = null;

  constructor(
    public store: Store,
    public element: ElementRef,
    public resizeService: ResizeService
  ) { }

  ngAfterViewInit(): void {
    this.boundingClientRect = this.element.nativeElement.getBoundingClientRect();
    this.store.dispatch({
      type: registerLayout.type,
      payload: {
        id: this.name,
        boundingClientRect: this.boundingClientRect
      }
    });

    this.resizeService.detectObservable.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const boundingClientRect = this.element.nativeElement.getBoundingClientRect();
      if(boundingClientRect.height !== this.boundingClientRect.height) {
        this.store.dispatch({
          type: registerLayout.type,
          payload: {
            id: this.name,
            boundingClientRect: boundingClientRect
          }
        });
        this.boundingClientRect = boundingClientRect;
      }
    });
    this.resizeService.resizeObservable.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      const boundingClientRect = this.element.nativeElement.getBoundingClientRect();
      this.store.dispatch({
        type: registerLayout.type,
        payload: {
          id: this.name,
          boundingClientRect: boundingClientRect
        }
      });
      this.boundingClientRect = boundingClientRect;
    })
  }

  ngOnDestroy(): void {
    this.store.dispatch({
      type: unregisterLayout.type,
      payload: {
        id: this.name,
        boundingClientRect: this.element.nativeElement.getBoundingClientRect()
      }
    });
  }
}
